// Pure helpers for the voice-sample recorder, kept apart from the screen so they can be tested.

// Leaving the page while recording throws the recording away: its "stopped" handler (which uploads) is
// removed first, so a half-finished clip is never saved as the person's voice sample.
export function discardRecorder(recorder) {
  if (!recorder || recorder.state === "inactive") return;
  recorder.onstop = null;
  recorder.stream?.getTracks().forEach((track) => track.stop());
  recorder.stop();
}

// A voice sample has no public link: its address is a signed-in endpoint, so it is fetched with the
// person's own session and played from a local object URL (the caller revokes it when done).
export async function sampleSource(fetchBlob, path, makeObjectUrl = (blob) => URL.createObjectURL(blob)) {
  if (!path) return null;
  return makeObjectUrl(await fetchBlob(path));
}

// A new sample replaces the old ones only once it has been saved. If the upload fails nothing is deleted;
// an old sample that cannot be removed afterwards is reported back instead of being hidden.
export async function replaceSample({ upload, remove, previousIds }) {
  await upload();
  const stuck = [];
  for (const id of previousIds) {
    try {
      await remove(id);
    } catch {
      stuck.push(id);
    }
  }
  return { stuck };
}
